
import React, { useState,useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { Box, Grid, TextField, Button, Typography, Autocomplete } from '@mui/material';
import { Formik, Form} from 'formik';
import { ClinicDetailsById, ClinicInfoFormData, getCityList, initialClinicFormValues, validationSchema } from './clinicHelper';
import { getcountryList, getCountryStateList } from '../../services/apiService';
import { RequiredLabel } from '../../utils/commonUtils';
import DepartmentStoreSelect from './DepartmentStoreSelect';
import { useParams } from 'react-router-dom';
import { CountryData, State } from '../../types';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


interface ClinicInfoFormProps {
  onCancel?: () => void;
}




const ClinicAddEditInfoForm: React.FC<ClinicInfoFormProps> = ({ onCancel }) => {
  const { t: tClinic } = useTranslation('clinic_config');
  const steps = [
    // eslint-disable-next-line no-constant-binary-expression
    tClinic('AddNewClinic_Page.Clinic_Details'),
    tClinic('AddNewClinic_Page.Department_Store_Details'),
  ];
  const [selectedCountry, setSelectedCountry] = useState<string>('');
  const [selectedState, setSelectedState] = useState<string>('');
  const [cities, setCities] = useState<string[]>([]);
  const [isLoadingCities, setIsLoadingCities] = useState(false);
  const [initialValues, setInitialValues] = useState<ClinicInfoFormData>(initialClinicFormValues);
  const[formSubmitedvalues, setFormSubmitedValues] = useState<ClinicInfoFormData | null>(null);
  const [activeStep, setActiveStep] = useState(0);
  const { id } = useParams<{ id?: string }>();
  const navigate = useNavigate();
  const [countries, setCountries] = useState<string[]>([]);
  const [states, setStates] = useState<string[]>([]);
  const [isLoadingStates, setIsLoadingStates] = useState(false);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        getcountryList().then((res) => {
          setCountries(res.data.map((country:CountryData) => country.country));
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching country list:', error);
      }
    };
    fetchCountries();
  }, []);

  const fetchStates = (country: string) => {
    setIsLoadingStates(true);
    getCountryStateList(country).then((res) => {
      if (res.data && res.data.states) {
        setStates(res.data.states.map((state:State) => state.name));
      } else {
        setStates([]);
      }
      setIsLoadingStates(false);
    });
  };
 
  useEffect(() => {
    if (id) {
      ClinicDetailsById(id)
        .then((data: ClinicInfoFormData) => {
          setInitialValues(data);
          setSelectedCountry(data.country || '');
          setSelectedState(data.state || '');
        });
    }
  }, [id]);

  const handleCancel = () => {
    if (id) {
      // In edit mode, navigate back to the clinic list
      navigate('/ai/configuration/clinic');
    } else if (onCancel) {
      // In add mode, call onCancel to close the form
      onCancel();
    }
  };
  const handleSubmit = (values: ClinicInfoFormData) => {
    // eslint-disable-next-line no-console
    console.log('Submitted values:', values);
    setFormSubmitedValues(values);
    setActiveStep(1); 
  };

  const renderStepper = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', mb: 3 }}>
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>{tClinic('AddNewClinic_Page.Text_AddNewClinic')}</Typography>
      <Box>
        <Box
          sx={{
            borderRadius: 3,
            p: 1.5,
            width: 700,
            display: 'flex',
            alignItems: 'center',
            background: '#fff',
            boxShadow: 1,
          }}
        >
          {steps.map((label, idx) => (
            <React.Fragment key={label}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: '50%',
                    background: idx === activeStep ? '#FFEBE6' : '#BDBDBD',
                    color: idx === activeStep ? '#FF6F61' : '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 600,
                    fontSize: 16,
                    transition: 'background 0.2s',
                  }}
                >
                  {idx + 1}
                </Box>
                <Typography
                  sx={{
                    color: idx === activeStep ? '#FF6F61' : '#757575',
                    fontWeight: idx === activeStep ? 600 : 500,
                    fontSize: 16,
                    ml: 0.5,
                    mr: 0,
                    transition: 'color 0.2s',
                  }}
                >
                  {label}
                </Typography>
              </Box>
              {idx < steps.length - 1 && (
                <Box
                  sx={{
                    width: 48,
                    height: 2,
                    bgcolor: '#E0E0E0',
                    mx: 1,
                    borderRadius: 1,
                  }}
                />
              )}
            </React.Fragment>
          ))}
        </Box>
      </Box>
    </Box>
  );

  return (
    <Box width="100%" p={2}>
      {renderStepper()}
      {activeStep === 0 ? (
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={(values) => {
            handleSubmit(values);
          }}
        >
          {({
            errors,
            handleBlur,
            handleChange,
            // handleSubmit,
            // isSubmitting,
            setFieldValue,
            // submitForm,
            touched,
            values,
          // resetForm 
          }) => (
            <>
              <Form>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Clinic Name'), true)}
                      name="name"
                      value={values.name}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.name && Boolean(errors.name)}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Code */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Code'), true)}
                      name="code"
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.code && Boolean(errors.code)}
                      helperText={touched.code && errors.code}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Description */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_description'), true)}
                      name="description"
                      value={values.description}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.description && Boolean(errors.description)}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Clinic Email */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Clinic Email'), true)}
                      name="email"
                      value={values.email}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.email && Boolean(errors.email)}
                      helperText={touched.email && errors.email}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Mobile No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Mobile No.'), true)}
                      name="phone"
                      value={values.phone}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.phone && Boolean(errors.phone)}
                      helperText={touched.phone && errors.phone}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Country (Autocomplete) */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                      options={countries}
                      value={selectedCountry}
                      onChange={(_, value) => {
                        setSelectedCountry(value || '');
                        setFieldValue('country', value);
                        fetchStates(value || '');
                        setSelectedState('');
                        setFieldValue('state', '');
                        setCities([]);
                        setFieldValue('city', '');
                      }}
                      onBlur={handleBlur}
                      loading={countries.length === 0}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Country'), true)}
                          fullWidth
                          size="small"
                          variant="outlined"
                          error={touched.country && Boolean(errors.country)}
                        />
                      )}
                    />
                  </Grid>
                  {/* State (Autocomplete) */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                      options={states}
                      value={selectedState}
                      onChange={(_, value) => {
                        setSelectedState(value || '');
                        setFieldValue('state', value);
                        setFieldValue('city', '');
                        setCities([]);
                        if (selectedCountry && value) {
                          setIsLoadingCities(true);
                          getCityList(selectedCountry, value).then((cityList) => {
                            setCities(cityList?.data || []);
                            setIsLoadingCities(false);
                          }).catch(() => {
                            setCities([]);
                            setIsLoadingCities(false);
                          });
                        }
                      }}
                      onBlur={handleBlur}
                      loading={isLoadingStates}
                      disabled={!selectedCountry}
                      sx={{
                        backgroundColor: !selectedCountry ? '#F5F5F5' : 'inherit',
                        borderRadius: '12px',
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tClinic('AddNewClinic_Page.Text_State'), true)}
                          fullWidth
                          size="small"
                          variant="outlined"
                          error={touched.state && Boolean(errors.state)}
                        />
                      )}
                    />
                  </Grid>
                  {/* City (Autocomplete) */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                      options={cities}
                      value={values.city || ''}
                      onChange={(_, value) => setFieldValue('city', value)}
                      onBlur={handleBlur}
                      loading={isLoadingCities}
                      disabled={!selectedState}
                      sx={{
                        backgroundColor: !selectedState ? '#F5F5F5' : 'inherit',
                        borderRadius: '12px',
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={RequiredLabel(tClinic('AddNewClinic_Page.Text_City'), true)}
                          fullWidth
                          size="small"
                          variant="outlined"
                          error={touched.city && Boolean(errors.city)}
                        />
                      )}
                    />
                  </Grid>
                  {/* Address Line 1 */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Address Line 1'), true)}
                      name="line_1"
                      value={values.line_1}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.line_1 && Boolean(errors.line_1)}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Address Line 2 */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Address Line 2')}
                      name="line_2"
                      value={values.line_2}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.line_2 && Boolean(errors.line_2)}
                      helperText={touched.line_2 && errors.line_2}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Pin/Zip Code */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Pin/Zip Code')}
                      name="pincode"
                      value={values.pincode}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.pincode && Boolean(errors.pincode)}
                      variant="outlined"
                    />
                  </Grid>
                  {/* TIN No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_VAT No.')}
                      name="tin_no"
                      value={values.tin_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.tin_no && Boolean(errors.tin_no)}
                      helperText={touched.tin_no && errors.tin_no}
                      variant="outlined"
                    />
                  </Grid>
                  {/* GST IN No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_GST IN No.')}
                      name="gst_no"
                      value={values.gst_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.gst_no && Boolean(errors.gst_no)}
                      helperText={touched.gst_no && errors.gst_no}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Clinic Fax No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Clinic Fax No.')}
                      name="fax_no"
                      value={values.fax_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.fax_no && Boolean(errors.fax_no)}
                      helperText={touched.fax_no && errors.fax_no}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Cluster (Autocomplete) */}
                  <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                      options={['Cluster A', 'Cluster B', 'Cluster C']}
                      value={values.cluster || ''}
                      onChange={(_, value) => setFieldValue('cluster', value)}
                      onBlur={handleBlur}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={tClinic('AddNewClinic_Page.Text_Cluster')}
                          fullWidth
                          size="small"
                          variant="outlined"
                          error={touched.cluster && Boolean(errors.cluster)}
                          helperText={touched.cluster && errors.cluster}
                        />
                      )}
                    />
                  </Grid>
                  {/* Server */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Server')}
                      name="server"
                      value={values.server}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.server && Boolean(errors.server)}
                      helperText={touched.server && errors.server}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Database */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Database')}
                      name="database"
                      value={values.database}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.database && Boolean(errors.database)}
                      helperText={touched.database && errors.database}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Pharmacy License No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Drug License No.')}
                      name="licence_no"
                      value={values.licence_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.licence_no && Boolean(errors.licence_no)}
                      helperText={touched.licence_no && errors.licence_no}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Clinic Registration No. (CIN) */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={RequiredLabel(tClinic('AddNewClinic_Page.Text_Clinic Registration No. (CIN)'), true)}
                      name="regitration_no"
                      value={values.regitration_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.regitration_no && Boolean(errors.regitration_no)}
                      variant="outlined"
                    />
                  </Grid>
                  {/* Shop Or Establishment No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_Shop Or Establishment No.')}
                      name="establishment_no"
                      value={values.establishment_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.establishment_no && Boolean(errors.establishment_no)}
                      helperText={touched.establishment_no && errors.establishment_no}
                      variant="outlined"
                    />
                  </Grid>
                  {/* PAN No. */}
                  <Grid item xs={12} sm={6} md={4}>
                    <TextField
                      fullWidth
                      size="small"
                      label={tClinic('AddNewClinic_Page.Text_PAN No.')}
                      name="pan_no"
                      value={values.pan_no}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={touched.pan_no && Boolean(errors.pan_no)}
                      helperText={touched.pan_no && errors.pan_no}
                      variant="outlined"
                    />
                  </Grid>
                </Grid>
                <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>
                  <Button variant="outlined" type="button" onClick={handleCancel}>{tClinic('AddNewClinic_Page.CancelButton')}</Button>
                  <Button variant="contained" type="submit" sx={{ backgroundColor: '#3e3e3e', color: '#fff', boxShadow: 'none', '&:hover': { backgroundColor: '#222' } } }>{tClinic('AddNewClinic_Page.SaveAndNextButton')}</Button>
                </Box>
              </Form>
            </>
          )}
        </Formik>
      ):(
        <DepartmentStoreSelect onCancel={handleCancel} formSubmitedvalues = {formSubmitedvalues} />

      )}
    </Box>
  );
};

export default ClinicAddEditInfoForm;
